import request from '../request';
const baseUrl = process.env.NODE_ENV !== 'production'
    ? 'individual' // 开发环境
    : 'individual'; // 生产环境
// 获取自然人信息
export function getIndividualInfo(serialNo) {
    return request.post(baseUrl + '/info', { serialNo });
}
// 编辑/修改自然人信息
export function modifyIndividualInfo(param) {
    return request.post(baseUrl + '/info/edit', param);
}
// 获取工作经历
export function getIndividualExperienceJob(page) {
    return request.post(baseUrl + '/experience/job', page);
}
// 【Offer】Offer列表
export function getOfferListJob() {
    return request.post(baseUrl + '/offer/list');
}
// 回应工作邀约/Offer
export function responseOffer(param) {
    return request.post(baseUrl + '/offer/respond', param);
}
// 【Offer】接受Offer
export function offerAcceptApi(id, splitter) {
    return request.post(baseUrl + '/offer/accept', { id, splitter });
}
// 【Offer】接受Offer
export function offerRejectApi(id, splitter) {
    return request.post(baseUrl + '/offer/reject', { id, splitter });
}
// 获取工作详情
export function getOfferDetailAPI(offerId) {
    return request.post(baseUrl + '/offer/detail', { offerId });
}
// 获取用户关注的匹配收藏
export function followedMatchesAPI() {
    return request.post('/user/followed/matches');
}
export default { getIndividualInfo };
